// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav-link-text {
    background-color: transparent !important;
    font-size: 14px !important;
}

.nav-item {
    margin-left: 0 !important;
    padding-left: 0 !important;
}

.nav {
    width: 100% !important;
}

.collapse.show {
    justify-content: flex-start !important;
}

.sidebar-icon-img {
    width: 25px;
    height: auto;
    cursor: pointer;
}

/* ================================
   Main module navigation
================================ */

.main-links-section {
    display: flex;
    align-items: flex-start;
    width: 100%;
    min-width: 0;
    overflow: hidden;
}

.navigation-rail {
    width: 115px;
    min-width: 115px;
    margin-left: 0.3rem;
    flex-shrink: 0;
    transition:
        width 0.3s ease-in-out,
        min-width 0.3s ease-in-out;
}

/*
 * When a submenu is active, shrink the module rail to its icon width
 * so the submenu has enough room inside the sidebar.
 */
.navigation-rail:has(.active-submenu) {
    width: 45px;
    min-width: 45px;
}

.navigation-rail .nav-link {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    white-space: nowrap;
}

.navigation-rail .module-name {
    display: inline-block;
    flex-shrink: 0;
}

.home .nav-link-text {
    margin-left: 16px;
}

/* Module name is visible when its submenu is closed. */
.module-name {
    margin-left: 20px;
    opacity: 1;
    transform: translateX(0);
    pointer-events: auto;
    transition:
        opacity 0.25s ease-in-out 0.3s,
        transform 0.25s ease-in-out 0.3s;
}

/* Hide the module name immediately when its submenu opens. */
.module-name.active-submenu {
    opacity: 0;
    transform: translateX(-20px);
    pointer-events: none;
    transition:
        opacity 0.25s ease-in-out,
        transform 0.25s ease-in-out;
}

.collapse.show.sidebar * {
    padding-left: 0;
}

/* ================================
   Module submenus
================================ */

.sub-menu {
    flex: 1 1;
    min-width: 0;
    width: 0;
    max-width: 0 !important;
    opacity: 0;
    overflow: hidden;
    transform: translateX(-20px);
    transition:
        width 0.3s ease-in-out,
        max-width 0.3s ease-in-out,
        opacity 0.3s ease-in-out,
        transform 0.3s ease-in-out;
}

.sub-menu.hucs,
.sub-menu.hrms,
.sub-menu.mdm {
    width: 200px;
    max-width: 200px !important;
    opacity: 1;
    transform: translateX(0);
}

.icon-highlight.nav-link {
    cursor: pointer;
    padding-right: 0.2rem !important;
}

.hrms.icon-highlight.active-submenu::before {
    content: "";
    position: absolute;
    right: 0;
    bottom: -4px;
    width: 5px;
    height: 20px;
    background-color: inherit;
    border-radius: 0 0 0 10px;
}

.hucs.icon-highlight.active-submenu::before {
    content: "";
    position: absolute;
    right: 0;
    bottom: -4px;
    width: 5px;
    height: 43px;
    background-color: inherit;
    border-radius: 10px 0 0 10px;
}

.icon-highlight {
    position: relative;
    border-radius: 10px 0 0 10px !important;
}

.icon-highlight::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 0;
    height: 100%;
    background-color: #a11002;
    transition: width 0.4s ease;
}

.icon-highlight.hrms {
    background-color: #d06c01 !important;
}

.icon-highlight.hucs {
    width: 100%;
}

.icon-highlight.mdm {
    background-color: #146f06 !important;
}

.sub-menu.hrms {
    border-radius: 0 10px 10px 10px;
}

.sub-menu.hucs,
.sub-menu.mdm {
    border-radius: 10px;
}

/* ================================
   Lists and route links
================================ */

.husaria-sidebar ul {
    padding: 0;
    margin: 0;
    list-style: none;
}

.husaria-sidebar li {
    list-style: none;
}

.route-link.dashboard {
    margin-left: 0 !important;
}

.hucs .route-link:not(.dashboard) {
    padding-left: 41px !important;
}

.hucs .devices-active {
    padding-left: 14px;
}

.hucs .devices .route-link {
    padding-left: 52px !important;
}

/* ================================
   Collapsed sidebar
================================ */

/*
 * Apply the icon-only layout only while the sidebar is collapsed
 * and is not being temporarily previewed through hover.
 */
.husaria-sidebar.sidebar-collapsed:not(:hover) {
    overflow: hidden;
}

/* Hide the logo in the fully collapsed state. */
.husaria-sidebar.sidebar-collapsed:not(:hover) .navbar-brand {
    display: none;
}

.husaria-sidebar.sidebar-collapsed:not(:hover) .sidenav-header {
    justify-content: center;
    padding-right: 0;
    padding-left: 0;
}

.husaria-sidebar.sidebar-collapsed:not(:hover) .sidenav-header .ml-auto {
    margin-left: 0 !important;
}

/* Hide labels only in the fully collapsed state. */
.husaria-sidebar.sidebar-collapsed:not(:hover) .nav-link-text,
.husaria-sidebar.sidebar-collapsed:not(:hover) .navbar-heading,
.husaria-sidebar.sidebar-collapsed:not(:hover) .docs-normal,
.husaria-sidebar.sidebar-collapsed:not(:hover) .module-name {
    display: none !important;
}

/* Hide the submenu so it cannot overflow into the page. */
.husaria-sidebar.sidebar-collapsed:not(:hover) .sub-menu {
    display: none !important;
    width: 0 !important;
    min-width: 0 !important;
    max-width: 0 !important;
}

/* Let the icon rail fill the collapsed sidebar. */
.husaria-sidebar.sidebar-collapsed:not(:hover) .main-links-section,
.husaria-sidebar.sidebar-collapsed:not(:hover) .navigation-rail,
.husaria-sidebar.sidebar-collapsed:not(:hover) .navigation-rail:has(.active-submenu) {
    width: 100% !important;
    min-width: 0 !important;
}

.husaria-sidebar.sidebar-collapsed:not(:hover) .navigation-rail {
    margin-left: 0;
}

/* Centre visible navigation icons. */
.husaria-sidebar.sidebar-collapsed:not(:hover) .nav-link,
.husaria-sidebar.sidebar-collapsed:not(:hover) .account-links {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 44px;
    padding: 0 !important;
    margin: 0 !important;
}

.husaria-sidebar.sidebar-collapsed:not(:hover) .sidebar-icon,
.husaria-sidebar.sidebar-collapsed:not(:hover) .sidebar-icon-img,
.husaria-sidebar.sidebar-collapsed:not(:hover) .account-links>i {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    min-width: 24px;
    margin: 0 !important;
}

/* Remove expanded module shapes from the icon-only layout. */
.husaria-sidebar.sidebar-collapsed:not(:hover) .icon-highlight,
.husaria-sidebar.sidebar-collapsed:not(:hover) .icon-highlight.hucs {
    width: 100% !important;
    border-radius: 0 !important;
}

/* Remove decorative submenu extensions while collapsed. */
.husaria-sidebar.sidebar-collapsed:not(:hover) .icon-highlight.active-submenu::before {
    display: none;
}

/* Keep separators inside the narrow sidebar. */
.husaria-sidebar.sidebar-collapsed:not(:hover) hr {
    width: 36px;
    margin-right: auto;
    margin-left: auto;
}

/* =================================
   Consistent top-level alignment
================================= */

.husaria-sidebar .navigation-rail {
    margin-left: 0;
}

/* Give every top-level link the same two-column layout. */
.husaria-sidebar .home.account-links,
.husaria-sidebar .navigation-rail>.icon-highlight,
.husaria-sidebar .navbar-inner .account-links {
    display: grid;
    grid-template-columns: 25px minmax(0, 1fr);
    align-items: center;
    grid-column-gap: 16px;
    column-gap: 16px;
    padding-left: 16px !important;
}

/* Every icon occupies the same fixed column. */
.husaria-sidebar .home.account-links>.sidebar-icon,
.husaria-sidebar .navigation-rail>.icon-highlight>.sidebar-icon-img,
.husaria-sidebar .navbar-inner .account-links>i {
    width: 25px !important;
    min-width: 25px !important;
    margin: 0 !important;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    grid-column: 1;
}

/* Prevent the icon inside the home wrapper from adding more spacing. */
.husaria-sidebar .home.account-links>.sidebar-icon>i {
    width: auto !important;
    min-width: 0 !important;
    margin: 0 !important;
}

/* Align every label in the same text column. */
.husaria-sidebar .home.account-links>.nav-link-text,
.husaria-sidebar .navigation-rail>.icon-highlight>.module-name,
.husaria-sidebar .navbar-inner .account-links>.nav-link-text {
    grid-column: 2;
    margin-left: 0 !important;
    white-space: nowrap;
}

/* Vertically center the Account links and their active highlight */
.husaria-sidebar .navbar-inner .account-links {
    display: flex !important;
    align-items: center !important;
    height: 34px;
    min-height: 34px;
    box-sizing: border-box;
    padding: 0 16px !important;
    gap: 16px;
}

.husaria-sidebar .navbar-inner .account-links>i {
    flex: 0 0 25px;
    width: 25px !important;
    min-width: 25px !important;
    margin: 0 !important;
    line-height: 1 !important;
    text-align: center;
}

.husaria-sidebar .navbar-inner .account-links>.nav-link-text {
    margin: 0 !important;
    line-height: 1 !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Sidebar/css/Sidebar.css"],"names":[],"mappings":"AAAA;IACI,wCAAwC;IACxC,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;;kCAEkC;;AAElC;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd;;kCAE8B;AAClC;;AAEA;;;EAGE;AACF;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,uDAAuD;AACvD;IACI,iBAAiB;IACjB,UAAU;IACV,wBAAwB;IACxB,oBAAoB;IACpB;;wCAEoC;AACxC;;AAEA,6DAA6D;AAC7D;IACI,UAAU;IACV,4BAA4B;IAC5B,oBAAoB;IACpB;;mCAE+B;AACnC;;AAEA;IACI,eAAe;AACnB;;AAEA;;kCAEkC;;AAElC;IACI,SAAO;IACP,YAAY;IACZ,QAAQ;IACR,uBAAuB;IACvB,UAAU;IACV,gBAAgB;IAChB,4BAA4B;IAC5B;;;;kCAI8B;AAClC;;AAEA;;;IAGI,YAAY;IACZ,2BAA2B;IAC3B,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,uCAAuC;AAC3C;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;;kCAEkC;;AAElC;IACI,UAAU;IACV,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;;kCAEkC;;AAElC;;;EAGE;AACF;IACI,gBAAgB;AACpB;;AAEA,gDAAgD;AAChD;IACI,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,mDAAmD;AACnD;;;;IAII,wBAAwB;AAC5B;;AAEA,0DAA0D;AAC1D;IACI,wBAAwB;IACxB,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA,kDAAkD;AAClD;;;IAGI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA,qCAAqC;AACrC;;IAEI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;;;IAGI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,oBAAoB;AACxB;;AAEA,6DAA6D;AAC7D;;IAEI,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA,0DAA0D;AAC1D;IACI,aAAa;AACjB;;AAEA,+CAA+C;AAC/C;IACI,WAAW;IACX,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;;mCAEmC;;AAEnC;IACI,cAAc;AAClB;;AAEA,0DAA0D;AAC1D;;;IAGI,aAAa;IACb,0CAA0C;IAC1C,mBAAmB;IACnB,qBAAgB;IAAhB,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA,+CAA+C;AAC/C;;;IAGI,sBAAsB;IACtB,0BAA0B;IAC1B,oBAAoB;IACpB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA,uEAAuE;AACvE;IACI,sBAAsB;IACtB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA,+CAA+C;AAC/C;;;IAGI,cAAc;IACd,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA,mEAAmE;AACnE;IACI,wBAAwB;IACxB,8BAA8B;IAC9B,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,0BAA0B;IAC1B,SAAS;AACb;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,0BAA0B;IAC1B,oBAAoB;IACpB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,yBAAyB;AAC7B","sourcesContent":[".nav-link-text {\r\n    background-color: transparent !important;\r\n    font-size: 14px !important;\r\n}\r\n\r\n.nav-item {\r\n    margin-left: 0 !important;\r\n    padding-left: 0 !important;\r\n}\r\n\r\n.nav {\r\n    width: 100% !important;\r\n}\r\n\r\n.collapse.show {\r\n    justify-content: flex-start !important;\r\n}\r\n\r\n.sidebar-icon-img {\r\n    width: 25px;\r\n    height: auto;\r\n    cursor: pointer;\r\n}\r\n\r\n/* ================================\r\n   Main module navigation\r\n================================ */\r\n\r\n.main-links-section {\r\n    display: flex;\r\n    align-items: flex-start;\r\n    width: 100%;\r\n    min-width: 0;\r\n    overflow: hidden;\r\n}\r\n\r\n.navigation-rail {\r\n    width: 115px;\r\n    min-width: 115px;\r\n    margin-left: 0.3rem;\r\n    flex-shrink: 0;\r\n    transition:\r\n        width 0.3s ease-in-out,\r\n        min-width 0.3s ease-in-out;\r\n}\r\n\r\n/*\r\n * When a submenu is active, shrink the module rail to its icon width\r\n * so the submenu has enough room inside the sidebar.\r\n */\r\n.navigation-rail:has(.active-submenu) {\r\n    width: 45px;\r\n    min-width: 45px;\r\n}\r\n\r\n.navigation-rail .nav-link {\r\n    display: flex;\r\n    align-items: center;\r\n    flex-wrap: nowrap;\r\n    white-space: nowrap;\r\n}\r\n\r\n.navigation-rail .module-name {\r\n    display: inline-block;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.home .nav-link-text {\r\n    margin-left: 16px;\r\n}\r\n\r\n/* Module name is visible when its submenu is closed. */\r\n.module-name {\r\n    margin-left: 20px;\r\n    opacity: 1;\r\n    transform: translateX(0);\r\n    pointer-events: auto;\r\n    transition:\r\n        opacity 0.25s ease-in-out 0.3s,\r\n        transform 0.25s ease-in-out 0.3s;\r\n}\r\n\r\n/* Hide the module name immediately when its submenu opens. */\r\n.module-name.active-submenu {\r\n    opacity: 0;\r\n    transform: translateX(-20px);\r\n    pointer-events: none;\r\n    transition:\r\n        opacity 0.25s ease-in-out,\r\n        transform 0.25s ease-in-out;\r\n}\r\n\r\n.collapse.show.sidebar * {\r\n    padding-left: 0;\r\n}\r\n\r\n/* ================================\r\n   Module submenus\r\n================================ */\r\n\r\n.sub-menu {\r\n    flex: 1;\r\n    min-width: 0;\r\n    width: 0;\r\n    max-width: 0 !important;\r\n    opacity: 0;\r\n    overflow: hidden;\r\n    transform: translateX(-20px);\r\n    transition:\r\n        width 0.3s ease-in-out,\r\n        max-width 0.3s ease-in-out,\r\n        opacity 0.3s ease-in-out,\r\n        transform 0.3s ease-in-out;\r\n}\r\n\r\n.sub-menu.hucs,\r\n.sub-menu.hrms,\r\n.sub-menu.mdm {\r\n    width: 200px;\r\n    max-width: 200px !important;\r\n    opacity: 1;\r\n    transform: translateX(0);\r\n}\r\n\r\n.icon-highlight.nav-link {\r\n    cursor: pointer;\r\n    padding-right: 0.2rem !important;\r\n}\r\n\r\n.hrms.icon-highlight.active-submenu::before {\r\n    content: \"\";\r\n    position: absolute;\r\n    right: 0;\r\n    bottom: -4px;\r\n    width: 5px;\r\n    height: 20px;\r\n    background-color: inherit;\r\n    border-radius: 0 0 0 10px;\r\n}\r\n\r\n.hucs.icon-highlight.active-submenu::before {\r\n    content: \"\";\r\n    position: absolute;\r\n    right: 0;\r\n    bottom: -4px;\r\n    width: 5px;\r\n    height: 43px;\r\n    background-color: inherit;\r\n    border-radius: 10px 0 0 10px;\r\n}\r\n\r\n.icon-highlight {\r\n    position: relative;\r\n    border-radius: 10px 0 0 10px !important;\r\n}\r\n\r\n.icon-highlight::after {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 0;\r\n    height: 100%;\r\n    background-color: #a11002;\r\n    transition: width 0.4s ease;\r\n}\r\n\r\n.icon-highlight.hrms {\r\n    background-color: #d06c01 !important;\r\n}\r\n\r\n.icon-highlight.hucs {\r\n    width: 100%;\r\n}\r\n\r\n.icon-highlight.mdm {\r\n    background-color: #146f06 !important;\r\n}\r\n\r\n.sub-menu.hrms {\r\n    border-radius: 0 10px 10px 10px;\r\n}\r\n\r\n.sub-menu.hucs,\r\n.sub-menu.mdm {\r\n    border-radius: 10px;\r\n}\r\n\r\n/* ================================\r\n   Lists and route links\r\n================================ */\r\n\r\n.husaria-sidebar ul {\r\n    padding: 0;\r\n    margin: 0;\r\n    list-style: none;\r\n}\r\n\r\n.husaria-sidebar li {\r\n    list-style: none;\r\n}\r\n\r\n.route-link.dashboard {\r\n    margin-left: 0 !important;\r\n}\r\n\r\n.hucs .route-link:not(.dashboard) {\r\n    padding-left: 41px !important;\r\n}\r\n\r\n.hucs .devices-active {\r\n    padding-left: 14px;\r\n}\r\n\r\n.hucs .devices .route-link {\r\n    padding-left: 52px !important;\r\n}\r\n\r\n/* ================================\r\n   Collapsed sidebar\r\n================================ */\r\n\r\n/*\r\n * Apply the icon-only layout only while the sidebar is collapsed\r\n * and is not being temporarily previewed through hover.\r\n */\r\n.husaria-sidebar.sidebar-collapsed:not(:hover) {\r\n    overflow: hidden;\r\n}\r\n\r\n/* Hide the logo in the fully collapsed state. */\r\n.husaria-sidebar.sidebar-collapsed:not(:hover) .navbar-brand {\r\n    display: none;\r\n}\r\n\r\n.husaria-sidebar.sidebar-collapsed:not(:hover) .sidenav-header {\r\n    justify-content: center;\r\n    padding-right: 0;\r\n    padding-left: 0;\r\n}\r\n\r\n.husaria-sidebar.sidebar-collapsed:not(:hover) .sidenav-header .ml-auto {\r\n    margin-left: 0 !important;\r\n}\r\n\r\n/* Hide labels only in the fully collapsed state. */\r\n.husaria-sidebar.sidebar-collapsed:not(:hover) .nav-link-text,\r\n.husaria-sidebar.sidebar-collapsed:not(:hover) .navbar-heading,\r\n.husaria-sidebar.sidebar-collapsed:not(:hover) .docs-normal,\r\n.husaria-sidebar.sidebar-collapsed:not(:hover) .module-name {\r\n    display: none !important;\r\n}\r\n\r\n/* Hide the submenu so it cannot overflow into the page. */\r\n.husaria-sidebar.sidebar-collapsed:not(:hover) .sub-menu {\r\n    display: none !important;\r\n    width: 0 !important;\r\n    min-width: 0 !important;\r\n    max-width: 0 !important;\r\n}\r\n\r\n/* Let the icon rail fill the collapsed sidebar. */\r\n.husaria-sidebar.sidebar-collapsed:not(:hover) .main-links-section,\r\n.husaria-sidebar.sidebar-collapsed:not(:hover) .navigation-rail,\r\n.husaria-sidebar.sidebar-collapsed:not(:hover) .navigation-rail:has(.active-submenu) {\r\n    width: 100% !important;\r\n    min-width: 0 !important;\r\n}\r\n\r\n.husaria-sidebar.sidebar-collapsed:not(:hover) .navigation-rail {\r\n    margin-left: 0;\r\n}\r\n\r\n/* Centre visible navigation icons. */\r\n.husaria-sidebar.sidebar-collapsed:not(:hover) .nav-link,\r\n.husaria-sidebar.sidebar-collapsed:not(:hover) .account-links {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 100%;\r\n    min-height: 44px;\r\n    padding: 0 !important;\r\n    margin: 0 !important;\r\n}\r\n\r\n.husaria-sidebar.sidebar-collapsed:not(:hover) .sidebar-icon,\r\n.husaria-sidebar.sidebar-collapsed:not(:hover) .sidebar-icon-img,\r\n.husaria-sidebar.sidebar-collapsed:not(:hover) .account-links>i {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 24px;\r\n    min-width: 24px;\r\n    margin: 0 !important;\r\n}\r\n\r\n/* Remove expanded module shapes from the icon-only layout. */\r\n.husaria-sidebar.sidebar-collapsed:not(:hover) .icon-highlight,\r\n.husaria-sidebar.sidebar-collapsed:not(:hover) .icon-highlight.hucs {\r\n    width: 100% !important;\r\n    border-radius: 0 !important;\r\n}\r\n\r\n/* Remove decorative submenu extensions while collapsed. */\r\n.husaria-sidebar.sidebar-collapsed:not(:hover) .icon-highlight.active-submenu::before {\r\n    display: none;\r\n}\r\n\r\n/* Keep separators inside the narrow sidebar. */\r\n.husaria-sidebar.sidebar-collapsed:not(:hover) hr {\r\n    width: 36px;\r\n    margin-right: auto;\r\n    margin-left: auto;\r\n}\r\n\r\n/* =================================\r\n   Consistent top-level alignment\r\n================================= */\r\n\r\n.husaria-sidebar .navigation-rail {\r\n    margin-left: 0;\r\n}\r\n\r\n/* Give every top-level link the same two-column layout. */\r\n.husaria-sidebar .home.account-links,\r\n.husaria-sidebar .navigation-rail>.icon-highlight,\r\n.husaria-sidebar .navbar-inner .account-links {\r\n    display: grid;\r\n    grid-template-columns: 25px minmax(0, 1fr);\r\n    align-items: center;\r\n    column-gap: 16px;\r\n    padding-left: 16px !important;\r\n}\r\n\r\n/* Every icon occupies the same fixed column. */\r\n.husaria-sidebar .home.account-links>.sidebar-icon,\r\n.husaria-sidebar .navigation-rail>.icon-highlight>.sidebar-icon-img,\r\n.husaria-sidebar .navbar-inner .account-links>i {\r\n    width: 25px !important;\r\n    min-width: 25px !important;\r\n    margin: 0 !important;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    grid-column: 1;\r\n}\r\n\r\n/* Prevent the icon inside the home wrapper from adding more spacing. */\r\n.husaria-sidebar .home.account-links>.sidebar-icon>i {\r\n    width: auto !important;\r\n    min-width: 0 !important;\r\n    margin: 0 !important;\r\n}\r\n\r\n/* Align every label in the same text column. */\r\n.husaria-sidebar .home.account-links>.nav-link-text,\r\n.husaria-sidebar .navigation-rail>.icon-highlight>.module-name,\r\n.husaria-sidebar .navbar-inner .account-links>.nav-link-text {\r\n    grid-column: 2;\r\n    margin-left: 0 !important;\r\n    white-space: nowrap;\r\n}\r\n\r\n/* Vertically center the Account links and their active highlight */\r\n.husaria-sidebar .navbar-inner .account-links {\r\n    display: flex !important;\r\n    align-items: center !important;\r\n    height: 34px;\r\n    min-height: 34px;\r\n    box-sizing: border-box;\r\n    padding: 0 16px !important;\r\n    gap: 16px;\r\n}\r\n\r\n.husaria-sidebar .navbar-inner .account-links>i {\r\n    flex: 0 0 25px;\r\n    width: 25px !important;\r\n    min-width: 25px !important;\r\n    margin: 0 !important;\r\n    line-height: 1 !important;\r\n    text-align: center;\r\n}\r\n\r\n.husaria-sidebar .navbar-inner .account-links>.nav-link-text {\r\n    margin: 0 !important;\r\n    line-height: 1 !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
